import { connect } from "react-redux";
import injectIntl from "../../../../../../common/helpers/injectIntl";

import { post } from "../../../../../actions/general";
import { editTask } from "../../../../../store/plan/actions";

import Component from "./lazy";

export default injectIntl(connect(null, { post, editTask })(Component as any));
